// extracted by mini-css-extract-plugin
module.exports = {"button":"BadgeButton--button","buttonWithBadge":"BadgeButton--buttonWithBadge","label":"BadgeButton--label","badge":"BadgeButton--badge","isActive":"BadgeButton--isActive"};